module.exports = __webpack_public_path__ + "img/lens-167-minus-09.17f0b538.png";